export default "__VITE_ASSET__76fd5977__"